export enum TreeExpandBehaviour {

  ExpandNoInitial = 0,
  ExpandFirstLevel = 1,
  ExpandSecondLevel = 2,
  ExpandAll = 3

}